import { VariantConfig } from "./types";

export function coinFlip(
  variants: Record<string, VariantConfig>,
  dev: boolean,
) {
  const controlGroup = Object.keys(variants).find((variant) =>
    variant.startsWith("A-"),
  );

  if (dev && controlGroup) return controlGroup;

  const randomNumber = Math.random() * 100;

  for (const [variantName, variant] of Object.entries(variants)) {
    const [lower, upper] = variant.allocation;

    if (randomNumber >= lower && randomNumber < upper) {
      return variantName;
    }
  }

  return false;
}
